import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GlobalScope_instance2yi3ofovizf7l as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { writer1eia5its2a1fh as writer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import {
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  NoContent1bdx48poqrifq as NoContent,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { Companion_getInstance1wcuorfuztxv3 as Companion_getInstance } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { UnsupportedContentTypeException1omj39t4jp3a7 as UnsupportedContentTypeException } from '../call/utils.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { observable2pw4p3n7s3klf as observable } from '../utils/ByteChannelUtils.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getContent($this, delegate) {
  var tmp;
  if (delegate instanceof ContentWrapper()) {
    tmp = getContent($this, delegate.j5b());
  } else {
    if (delegate instanceof ByteArrayContent()) {
      tmp = ByteReadChannel(delegate.a5b());
    } else {
      if (delegate instanceof ProtocolUpgrade()) {
        throw UnsupportedContentTypeException().l5o(delegate);
      } else {
        if (delegate instanceof NoContent()) {
          tmp = Companion_getInstance().e4o_1;
        } else {
          if (delegate instanceof ReadChannelContent()) {
            tmp = delegate.d5b();
          } else {
            if (delegate instanceof WriteChannelContent()) {
              var tmp_0 = GlobalScope_instance;
              tmp = writer(tmp_0, $this.o5o_1, true, ObservableContent$getContent$slambda(delegate)).a4o_1;
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function ObservableContent$getContent$slambda($delegate) {
  return constructCallableReference(($this$writer, $completion) => orPromise($completion, function *($completion) {
    yield* $delegate.f5b($this$writer.k4o_1, $completion);
    return Unit_instance;
  }), 1);
}
var ObservableContentClass;
function ObservableContent() {
  if (ObservableContentClass === VOID) {
    class $ extends ReadChannelContent() {
      constructor(delegate, callContext, listener) {
        super();
        this.n5o_1 = delegate;
        this.o5o_1 = callContext;
        this.p5o_1 = listener;
      }
      p4a() {
        return this.n5o_1.p4a();
      }
      q4a() {
        return this.n5o_1.q4a();
      }
      e55() {
        return this.n5o_1.e55();
      }
      d5b() {
        return observable(getContent(this, this.n5o_1), this.o5o_1, this.q4a(), this.p5o_1);
      }
    }
    initMetadataForClass($, 'ObservableContent');
    ObservableContentClass = $;
  }
  return ObservableContentClass;
}
var ProgressListenerClass;
function ProgressListener() {
  if (ProgressListenerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ProgressListener', VOID, VOID, VOID, [2]);
    ProgressListenerClass = $;
  }
  return ProgressListenerClass;
}
//region block: exports
export {
  ObservableContent as ObservableContent3ft2pt0w2oysd,
  ProgressListener as ProgressListener886sg277haqw,
};
//endregion

//# sourceMappingURL=ObservableContent.mjs.map
